import React, { useState } from 'react';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Grid, Typography, Card, CardContent, IconButton } from '@mui/material';

import { infoIconStyle, infoIconButton } from '../../Dashboards/Market/styles/style';
import { TooltipCard } from '.';
import InfoTooltip from '../Tooltips/InfoTooltip';
import { DynamicBarChart } from 'src/App/Components/Charts';
import { BarDataCardPropTypes } from 'src/interfaces/iproptypes';
import { usePreview } from 'src/utils/hooks';
import { COLOR_PALETTE_1 } from 'src/const';
import { ViewDetailsButton } from 'src/App/Components/Buttons';
import { GraphPreview } from 'src/App/Components';
import { getPreviewTextObj } from 'src/utils/functions';
import UnlockButton from '../CTA/UnlockButton';

const BarDataCard = ({
  title,
  tooltipContent,
  data,
  orientation,
  unit,
  label,
  graphHeight,
  barColor,
  barAccentColor,
  isDisabled,
  graphPreviewDefaultTitle,
  handleOnSampleClick,
  previewTextObj,
}: BarDataCardPropTypes) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [isPreview, handlePreviewMode] = usePreview() as [boolean, () => void];

  return (
    <Grid
          container
          direction="column"
          justifyContent="space-between"
          alignItems="flex-start"
          item
          style={{ position: 'relative' }}
        >      
          <Typography variant="body1" className='subHeadings'>
            {title}
            {tooltipContent && (
              <InfoTooltip
                title={
                  <TooltipCard
                    title={title}
                    content={tooltipContent}
                    link="https://support.airbtics.com/"
                  />
                }
                enterTouchDelay={0}
                leaveTouchDelay={6000}
                open={tooltipOpen}
                onOpen={() => setTooltipOpen(true)}
                onClose={() => setTooltipOpen(false)}
              >
                <IconButton style={infoIconButton} onClick={() => setTooltipOpen(prev => !prev)}>
                  <InfoOutlinedIcon style={infoIconStyle} />
                </IconButton>
              </InfoTooltip>
            )}
          </Typography>

          <Grid item sx={{ width: '100%' }}>
            {isPreview && previewTextObj ? (
              <GraphPreview
                parent="demand"
                variant="bookingType"
                useFriendlyDataName={
                  isDisabled
                    ? graphPreviewDefaultTitle
                      ? graphPreviewDefaultTitle
                      : ''
                    : previewTextObj.userFriendlyDataName
                }
                previewVal={previewTextObj.previewVal}
                isDisabled={isDisabled}
              />
            ) : (
              <DynamicBarChart
                layout={orientation}
                data={data}
                unit={unit}
                label={label}
                height={graphHeight}
                barColor={barColor}
                barAccentColor={barAccentColor}
              />
            )}
          </Grid>

          {previewTextObj && (
            <ViewDetailsButton
              color={COLOR_PALETTE_1}
              isPreview={isPreview}
              handlePreviewMode={
                isDisabled
                  ? handleOnSampleClick
                    ? handleOnSampleClick
                    : () => {}
                  : handlePreviewMode
              }
            />
          )}

          {isDisabled && (
            <UnlockButton
              fontSizeHeading="small"
              handleOnSampleClick={handleOnSampleClick ? handleOnSampleClick : () => {}}
              noBackdrop={true}
            />
          )}
        </Grid>
  );
};

export default React.memo(BarDataCard);
